import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchPatientAiScoreHistory = async ({ trialId, patientId, token }) => {
  const authToken = token || localStorage.getItem("token");

  const res = await axios.get(
    `${__API_URL__}/api/ecrf/trial/${trialId}/patient/${patientId}/ai-score-history/`,
    {
      headers: {
        Authorization: `Token ${authToken}`,
      },
    }
  );

  return res.data;
};

const useGetPatientAiScoreHistory = ({ trialId, patientId, token, enabled = true }) => {
  return useQuery({
    queryKey: ["patient_ai_score_history", trialId, patientId],
    queryFn: () => fetchPatientAiScoreHistory({ trialId, patientId, token }),
    enabled: enabled && Boolean(trialId) && Boolean(patientId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load AI score history");
    },
  });
};

export default useGetPatientAiScoreHistory;
